import { render, staticRenderFns } from "./NoFound.vue?vue&type=template&id=4e1c47ab&scoped=true"
import script from "./NoFound.vue?vue&type=script&lang=js"
export * from "./NoFound.vue?vue&type=script&lang=js"
import style0 from "./NoFound.vue?vue&type=style&index=0&id=4e1c47ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1c47ab",
  null
  
)

export default component.exports